import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../pages/Home.vue'
import advert from '../pages/Advert.vue'
import about from '../pages/About.vue'
Vue.use(VueRouter)

// 3. 配置路由规则数组
const routes = [
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: '/home',
        component: home
    },
    {
        path: '/about',
        component: about
    },
    {
        path: '/advert',
        component: advert
    }
]
// 4. 实例化VueRouter
const router = new VueRouter({
    routes
})
router.afterEach(() => {
    window.scrollTo(0, 0);
})
// 5. 导出路由实例对象router
export default router


// WEBPACK FOOTER //
// ./src/router/index.js